export const PATHS = {
  COMMENT: {
    LIST:
      'comment?website_url={websiteUrl}&post_id={postId}&page={page}&sort_by={sort}&items_per_page={perPage}&_without_reply={withoutReply}',
    CREATE: 'comment/create?website_url={websiteUrl}',
    REPLY: 'comment/reply?website_url={websiteUrl}',
    DELETE: 'comment/{id}/delete?website_url={websiteUrl}',
    LIKE: 'comment/{id}/like?website_url={websiteUrl}',
    UNLIKE: 'comment/{id}/unlike?website_url={websiteUrl}',
    IMAGE_UPLOAD: 'comment/image/upload?website_url={websiteUrl}',
    DETAIL: 'comment/{id}?website_url={websiteUrl}',
    UPDATE: 'comment/{id}/update?website_url={websiteUrl}',
  },
  BOOKMARK: {
    LIST: 'bookmark?user_id={userId}&website_url={websiteUrl}',
    CREATE: 'bookmark/create?website_url={websiteUrl}',
    DELETE: 'bookmark/delete?website_url={websiteUrl}&post_id={postId}',
  },
}

export const ADMIN_PATHS = {
  VIDEO_UPLOAD: 'admin/video/upload?website_url={website_url}',
  COMMENT: {
    IMAGE_UPLOAD: 'admin/comment/image/upload?website_url={website_url}',
  },
}
